import { PaymentElement } from "@stripe/react-stripe-js";
import type { StripePaymentElementChangeEvent } from "@stripe/stripe-js";
import { Input } from "../../../../components/common/input";
import { Heading } from "../../../../components/common/typography";

interface CardDetailsSectionProps {
  cardholderName: string;
  onCardholderNameChange: (v: string) => void;
  onCardChange?: (event: StripePaymentElementChangeEvent) => void;
}

/**
 * Wraps Stripe's `<PaymentElement>` (which renders the live card-number /
 * expiry / CVV inputs and handles all PCI-sensitive data) inside the
 * project's design-system card. The component MUST be rendered inside a
 * Stripe `<Elements>` provider — `PaymentView` provides one once the
 * payment intent is ready.
 *
 * Cardholder name is collected separately because the Stripe element
 * doesn't expose it as a structured field by default.
 */
export function CardDetailsSection({
  cardholderName,
  onCardholderNameChange,
  onCardChange,
}: CardDetailsSectionProps) {
  return (
    <div className="flex flex-col gap-4 rounded-2xl border border-borderDefault bg-bgWhite p-5">
      <Heading variant="h3" tone="dark">Card details</Heading>

      <Input
        label="Cardholder name"
        placeholder="Type cardholder name"
        value={cardholderName}
        onChange={(e) => onCardholderNameChange(e.target.value)}
      />

      <PaymentElement
        onChange={onCardChange}
        options={{
          layout: "tabs",
          fields: {
            billingDetails: {
              // We collect the cardholder name above and send it via
              // confirmPayment's `payment_method_data.billing_details.name`,
              // so hide Stripe's duplicate name field.
              name: "never",
            },
          },
        }}
      />
    </div>
  );
}
